















































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import UpdateWorkerTempTransportDetailsRequest from '@/models/Workers/UpdateWorkerTempTransportDetailsRequest';

@Component({
  components: {  },
    name: 'WorkerTempTransportDetailsEdit'
})
export default class extends GiganautVueDialog {

  public worker = new WorkerDto();
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
    }
  }

  get passengerOptions() {
    return ListUtils.passengerOptions();
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateWorkerTempTransportDetailsRequest();
    request.updatedAt = this.worker.updatedAt;
    request.isDriver = this.worker.isDriver;
    request.maximumPassengers = this.worker.maximumPassengers;

    await WorkerDetailsModule.editTempTransportDetails(request)
    this.dialog = false;
  }
}
